jng.setToCurrency = function(Value){
    let valueAsNum = 0
    if (jng.isString(Value)) {
        valueAsNum = jng.currencyToNumber(Value)            
    } else {
        valueAsNum = Math.round(Value * 100) / 100
    }
    var value = String(valueAsNum).trim();
    var arr1 = [];
    var arr2 = [];
    var inc = 0;
    // var isNegative = value.startsWith("-")
    // if (isNegative) value = value.substring(1)
    var valueComp = value.split(".")
    if (valueComp.length == 0) return ''
    value = valueComp[0]
    for(var data of value){
        arr1.push(data);
    };
    
    for(const data of arr1.reverse()){
        if(String(Number(data)) == "NaN"){
            continue;
        }

        if(inc == 3){
            arr2.push(',');
            inc = 0;
        }
        arr2.push(data);
        inc++;
    }

    var result = '';
    
    for(const val of arr2.reverse()){
        result = result.concat(val);
    }
    if (valueComp.length > 1) {
        result = result.concat(".")
        for(var digit of valueComp[1]) {
            result = result.concat(digit)
        }
    }
    // Value = result;
    if(valueAsNum < 0){
        result = "-"+result;
    }
    return result;
}

jng.currencyToNumber = function(value){
    return Number(String(value).replace(/,/g , ''));
};

Number.prototype.toRomawiString = function(){
    let romawi = ['', "I", "II", "III", "IV", "V", "VI", "VII", "VIII", "IX", "X", "XI", "XII", "XIII"];
    return romawi[this];
}

Number.prototype.toWordString = function(lang){
    let word = [];
    if(lang=="in"){
        word = ['Kosong', "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan", "Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas"];
    }else{
        word = ['Zero', "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen"];
    }
    return word[this];
}